{
  "queryName": "organisation",
  "queryParam": {
    "id": null
  },
  "fields": [
    "id",
    "name",
    "alternativeNames",
    "homepage",
    "rorLink",
    "types",
    "urlForLogo",
    {
      "name": "users",
      "fields": ["id", "username", "email", "orcid"]
    },
    {
      "name": "countries",
      "fields": ["name", "id", "code"]
    },
    {
      "name": "childOrganisations",
      "fields": ["id", "name"]
    },
    {
      "name": "parentOrganisations",
      "fields": ["id", "name"]
    },
    {
      "name": "organisationLinks",
      "fields": [
        "id",
        "isLead",
        "relation",
        {
          "queryName": "fairsharingRecord",
          "fields": [
            "id",
            "name",
            "abbreviation",
            "type",
            "registry",
            "status",
            "description",
            {
              "name": "subjects",
              "fields": ["id", "label", "iri", "definitions"]
            },
            {
              "name": "domains",
              "fields": ["id", "label", "iri", "definitions"]
            },
            {
              "name": "userDefinedTags",
              "fields": ["id", "label"]
            },
            {
              "name": "taxonomies",
              "fields": ["id", "label"]
            }
          ]
        },
        {
          "queryName": "grant",
          "fields": ["id", "name"]
        }
      ]
    },
    {
      "name": "savedSearches",
      "fields": [
        "id",
        "name",
        "url",
        {
          "queryName": "organisations",
          "fields": ["id", "name"]
        }
      ]
    }
  ]
}
